<template>
  <div class="reset-zoom" v-show="showControl">
    <div class="custom-control-div">
      <i class="icon-refresh_zoom" v-b-tooltip.hover.left :title="titles.refresh" @click.stop.prevent="resetZoom()" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ResetZoomControl',
  props: ['showControl'],
  mounted() {
    this.$parent.$mapPromise.then((m) => {
      m.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$el);
    });
  },
  methods: {
    resetZoom() {
      this.$emit('resetZoom');
    },
  },
  computed: {
    titles() {
      return {
        refresh: this.$gettext('Rafraichir la carte'),
      };
    },
  },
};
</script>
